import { render, staticRenderFns } from "./profilecardfirst.vue?vue&type=template&id=4ec39772"
import script from "./profilecardfirst.vue?vue&type=script&lang=js"
export * from "./profilecardfirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports